__turbopack_context__.v({
  "accordionSlideOverwrite": "articleCard-module-scss-module__rjPiWG__accordionSlideOverwrite",
  "card": "articleCard-module-scss-module__rjPiWG__card",
  "content": "articleCard-module-scss-module__rjPiWG__content",
  "ctaButton": "articleCard-module-scss-module__rjPiWG__ctaButton",
  "dark": "articleCard-module-scss-module__rjPiWG__dark",
  "date": "articleCard-module-scss-module__rjPiWG__date",
  "description": "articleCard-module-scss-module__rjPiWG__description",
  "fadeIn": "articleCard-module-scss-module__rjPiWG__fadeIn",
  "fadeOut": "articleCard-module-scss-module__rjPiWG__fadeOut",
  "horizontal": "articleCard-module-scss-module__rjPiWG__horizontal",
  "horizontalSmall": "articleCard-module-scss-module__rjPiWG__horizontalSmall",
  "image": "articleCard-module-scss-module__rjPiWG__image",
  "imageWrapper": "articleCard-module-scss-module__rjPiWG__imageWrapper",
  "navFeaturedTitle": "articleCard-module-scss-module__rjPiWG__navFeaturedTitle",
  "noHover": "articleCard-module-scss-module__rjPiWG__noHover",
  "scaleIn": "articleCard-module-scss-module__rjPiWG__scaleIn",
  "scaleOut": "articleCard-module-scss-module__rjPiWG__scaleOut",
  "title": "articleCard-module-scss-module__rjPiWG__title",
  "type": "articleCard-module-scss-module__rjPiWG__type",
  "zoomIn": "articleCard-module-scss-module__rjPiWG__zoomIn",
  "zoomOut": "articleCard-module-scss-module__rjPiWG__zoomOut",
});
